import { useState } from "react";
import { useLanguage } from "../../../../../../stores/LanguageStore";
import { Button, Group, Modal, Select, Stack, TextInput } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import { notifications } from "@mantine/notifications";
import BackButton from "../../../../../../components/View/BackButton";
import { createCron } from "../../../../../../api/ConfigsApi";
import { useParams } from "react-router-dom";
import CreatableContactListSelector from "../../../../../../components/Selectors/CreatableContactListSelector";
import LinkedinAccountSelector from "../../../../../../components/Selectors/LinkedinAccountSelector";

const CreateRefreshCron = ({ handleDone, defaultAccountId, ...props }) => {
  const lang = useLanguage((s) => s.language);
  const { contactListId } = useParams();
  const [opened, setOpened] = useState(false);
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState({ id: parseInt(contactListId) });
  const [accountId, setAccountId] = useState(defaultAccountId);

  const handleOpen = () => {
    setOpened(true);
  };
  const handleClose = () => {
    setOpened(false);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setLoading(true);
    let formData = new FormData(e.target);
    let data = Object.fromEntries(formData);

    const args = {
      type: "refresh_linkedin_targeting_contact_list",
      contactlist_id: parseInt(contactListId),
      linkedin_account_id: accountId,
    };

    createCron({
      name: data?.name,
      frequency: data?.frequency,
      args,
    })
      .then((response) => {
        notifications.show({
          message: lang.contact_lists.cron.created,
          color: "tertiary.8",
        });
        handleClose();
        handleDone();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <Button
        onClick={handleOpen}
        leftSection={<IconPlus size={18} />}
        size="md"
        {...props}
      >
        {lang.contact_lists.cron.new_cron}
      </Button>

      <Modal
        opened={opened}
        title={lang.contact_lists.cron.create_title_prm}
        onClose={handleClose}
        size={"50%"}
      >
        <Stack component={"form"} onSubmit={onSubmit}>
          <Group wrap="nowrap">
            <TextInput
              name="name"
              label={lang.contact_lists.cron.name}
              placeholder={"My cron"}
              required
              w={"100%"}
              autoFocus
              data-autofocus
              size="md"
            />

            <Select
              name="frequency"
              label={lang.sync_zapier.event_label}
              placeholder={lang.sync_zapier.event_label}
              defaultValue={"manual"}
              required
              data={Object.keys(lang.sync_zapier.frequency).map((x) => ({
                value: x,
                label: lang.sync_zapier.frequency[x],
              }))}
              size="md"
            />
          </Group>

          <CreatableContactListSelector
            value={list}
            setValue={setList}
            label={lang.contact_lists.cron.list_source}
            placeholder={lang.contact_lists.create.dialog.desc}
            w={"100%"}
            size="md"
            required
            disableCreate
            noDesc
          />

          <LinkedinAccountSelector
            label={lang.contact_lists.refresh_targeting.dialog.linkedin_account}
            required
            value={accountId}
            onChange={(v) => setAccountId(v?.id || null)}
            size={"md"}
          />

          <Group justify="end" mt={"lg"}>
            <BackButton onClick={handleClose} size="md" />
            <Button
              // disabled={
              //   type === "prm" ? !filter || filter?.values?.length === 0 : false
              // }
              leftSection={<IconPlus size={18} />}
              loading={loading}
              type="submit"
              size="md"
            >
              {lang.contact_lists.cron.create}
            </Button>
          </Group>
        </Stack>
      </Modal>
    </>
  );
};

export default CreateRefreshCron;
